<template>
  <div>
    <v-container style="width: 500px">
      <h2>
        管理者メニュー
      </h2>
      <v-btn
        class="ma-auto mt-5"
        color="primary"
        block
        x-large
        @click.prevent="onUsersListClicked()">
        調査診断協会会員一覧
      </v-btn>
      <v-btn
        class="ma-auto mt-5"
        color="primary"
        block
        x-large
        @click.prevent="onLogClicked()">
        画面操作ログ
      </v-btn>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'AdminIndex',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    onUsersListClicked() {
      this.$router.push({ name: 'userIndex' })
    },
    onLogClicked() {
      this.$router.push({ name: 'adminLog' })
    },
  },
}
</script>
